export class AgGridLocaleIt {

    public static AG_GRID_LOCALE_IT = {
        // Set Filter
        selectAll: '(Seleziona tutti)',
        selectAllSearchResults: '(Seleziona tutti i risultati di ricerca)',
        searchOoo: 'Cerca...',
        blanks: '(Spazi vuoti)',
        noMatches: 'Nessun risultato',
    
        // Number Filter & Text Filter
        filterOoo: 'Filtra...',
        equals: 'Uguale',
        notEqual: 'Non uguale',
        empty: 'Scegli Uno',
    
        // Number Filter
        lessThan: 'Meno di',
        greaterThan: 'Maggiore di',
        lessThanOrEqual: 'Minore o uguale di',
        greaterThanOrEqual: 'Maggiore o uguale di',
        inRange: 'Nel range',
        inRangeStart: 'da',
        inRangeEnd: 'a',
    
        // Text Filter
        contains: 'Contiene',
        notContains: 'Non contiene',
        startsWith: 'Inizia con',
        endsWith: 'Finisce con',
    
        // Date Filter
        dateFormatOoo: 'dd-mm-yyyy',
    
        // Filter Conditions
        andCondition: 'AND',
        orCondition: 'OR',
    
        // Filter Buttons
        applyFilter: 'Applica',
        resetFilter: 'Resetta',
        clearFilter: 'Pulisci',
        cancelFilter: 'Cancella',
    
        // Filter Titles
        textFilter: 'Filtro testo',
        numberFilter: 'Filtro numero',
        dateFilter: 'Filtro data',
        setFilter: 'Imposta filtro',
    
        // Side Bar
        columns: 'Colonne',
        filters: 'Filtri',
    
        // columns tool panel
        pivotMode: 'Modalità Pivot',
        groups: 'Gruppi riga',
        rowGroupColumnsEmptyMessage: 'Trascina qui per impostare i gruppi riga',
        values: 'Valori',
        valueColumnsEmptyMessage: 'Trascina qui per aggregare',
        pivots: 'Etichette colonne',
        pivotColumnsEmptyMessage: 'Trascina qui per impostare le etichette colonna',
    
        // Header of the Default Group Column
        group: 'Gruppo',
    
        // Other
        loadingOoo: 'Caricamento...',
        noRowsToShow: 'Nessuna riga da mostrare',
        enabled: 'Abilitato',
    
        // Menu
        pinColumn: 'Appunta Colonna',
        pinLeft: 'Appunta a sinistra',
        pinRight: 'Appunta a destra',
        noPin: 'Rimuovi appunto',
        valueAggregation: 'Aggregazione valori',
        autosizeThiscolumn: 'Auto-dimensiona questa colonna',
        autosizeAllColumns: 'Auto-dimensiona tutte le colonne',
        groupBy: 'Raggruppa per',
        ungroupBy: 'Separa per',
        resetColumns: 'Resetta colonne',
        expandAll: 'Espandi tutto',
        collapseAll: 'Chiudi tutto',
        copy: 'Copia',
        ctrlC: 'Ctrl+C',
        copyWithHeaders: 'Copia con Intestazioni',
        paste: 'Incolla',
        ctrlV: 'Ctrl+V',
        export: 'Esporta',
        csvExport: 'Esporta CSV',
        excelExport: 'Esporta Excel (.xlsx)',
        excelXmlExport: 'Esporta Excel (.xml)',
    
        // Enterprise Menu Aggregation and Status Bar
        sum: 'Somma',
        min: 'Min',
        max: 'Max',
        none: 'Nessuno',
        count: 'Conta',
        avg: 'Media',
        filteredRows: 'Filtro',
        selectedRows: 'Selezione',
        totalRows: 'Righe totali',
        totalAndFilteredRows: 'Righe',
        more: 'Di più',
        to: 'a',
        of: 'di',
        page: 'Pagina',
        nextPage: 'Pagina successiva',
        lastPage: 'Ultima pagina',
        firstPage: 'Prima pagina',
        previousPage: 'Pagina precedente',
    
        // Enterprise Menu (Charts)
        pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
        pivotChart: 'Pivot Chart',
        chartRange: 'Chart Range',
    
        columnChart: 'Column',
        groupedColumn: 'Grouped',
        stackedColumn: 'Stacked',
        normalizedColumn: '100% Stacked',
    
        barChart: 'Bar',
        groupedBar: 'Grouped',
        stackedBar: 'Stacked',
        normalizedBar: '100% Stacked',
    
        pieChart: 'Pie',
        pie: 'Pie',
        doughnut: 'Doughnut',
    
        line: 'Line',
    
        xyChart: 'X Y (Scatter)',
        scatter: 'Scatter',
        bubble: 'Bubble',
    
        areaChart: 'Area',
        area: 'Area',
        stackedArea: 'Stacked',
        normalizedArea: '100% Stacked',
    
        histogramChart: 'Histogram',
    
        // Charts
        pivotChartTitle: 'Pivot Chart',
        rangeChartTitle: 'Range Chart',
        settings: 'Settings',
        data: 'Data',
        format: 'Format',
        categories: 'Categories',
        defaultCategory: '(None)',
        series: 'Series',
        xyValues: 'X Y Values',
        paired: 'Paired Mode',
        axis: 'Axis',
        navigator: 'Navigator',
        color: 'Color',
        thickness: 'Thickness',
        xType: 'X Type',
        automatic: 'Automatic',
        category: 'Category',
        number: 'Number',
        time: 'Time',
        xRotation: 'X Rotation',
        yRotation: 'Y Rotation',
        ticks: 'Ticks',
        width: 'Width',
        height: 'Height',
        length: 'Length',
        padding: 'Padding',
        spacing: 'Spacing',
        chart: 'Chart',
        title: 'Title',
        titlePlaceholder: 'Chart title - double click to edit',
        background: 'Background',
        font: 'Font',
        top: 'Top',
        right: 'Right',
        bottom: 'Bottom',
        left: 'Left',
        labels: 'Labels',
        size: 'Size',
        minSize: 'Minimum Size',
        maxSize: 'Maximum Size',
        legend: 'Legend',
        position: 'Position',
        markerSize: 'Marker Size',
        markerStroke: 'Marker Stroke',
        markerPadding: 'Marker Padding',
        itemSpacing: 'Item Spacing',
        itemPaddingX: 'Item Padding X',
        itemPaddingY: 'Item Padding Y',
        layoutHorizontalSpacing: 'Horizontal Spacing',
        layoutVerticalSpacing: 'Vertical Spacing',
        strokeWidth: 'Stroke Width',
        offset: 'Offset',
        offsets: 'Offsets',
        tooltips: 'Tooltips',
        callout: 'Callout',
        markers: 'Markers',
        shadow: 'Shadow',
        blur: 'Blur',
        xOffset: 'X Offset',
        yOffset: 'Y Offset',
        lineWidth: 'Line Width',
        normal: 'Normal',
        bold: 'Bold',
        italic: 'Italic',
        boldItalic: 'Bold Italic',
        predefined: 'Predefined',
        fillOpacity: 'Fill Opacity',
        strokeOpacity: 'Line Opacity',
        histogramBinCount: 'Bin count',
        columnGroup: 'Column',
        barGroup: 'Bar',
        pieGroup: 'Pie',
        lineGroup: 'Line',
        scatterGroup: 'X Y (Scatter)',
        areaGroup: 'Area',
        histogramGroup: 'Histogram',
        groupedColumnTooltip: 'Grouped',
        stackedColumnTooltip: 'Stacked',
        normalizedColumnTooltip: '100% Stacked',
        groupedBarTooltip: 'Grouped',
        stackedBarTooltip: 'Stacked',
        normalizedBarTooltip: '100% Stacked',
        pieTooltip: 'Pie',
        doughnutTooltip: 'Doughnut',
        lineTooltip: 'Line',
        groupedAreaTooltip: 'Area',
        stackedAreaTooltip: 'Stacked',
        normalizedAreaTooltip: '100% Stacked',
        scatterTooltip: 'Scatter',
        bubbleTooltip: 'Bubble',
        histogramTooltip: 'Histogram',
        noDataToChart: 'No data available to be charted.',
        pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
        chartSettingsToolbarTooltip: 'Menu',
        chartLinkToolbarTooltip: 'Linked to Grid',
        chartUnlinkToolbarTooltip: 'Unlinked from Grid',
        chartDownloadToolbarTooltip: 'Download Chart',
    
        // ARIA
        ariaHidden: 'hidden',
        ariaVisible: 'visible',
        ariaChecked: 'checked',
        ariaUnchecked: 'unchecked',
        ariaIndeterminate:'indeterminate',
        ariaColumnSelectAll: 'Toggle Select All Columns',
        ariaInputEditor: 'Input Editor',
        ariaDateFilterInput: 'Date Filter Input',
        ariaFilterInput: 'Filter Input',
        ariaFilterColumnsInput: 'Filter Columns Input',
        ariaFilterValue: 'Filter Value',
        ariaFilterFromValue: 'Filter from value',
        ariaFilterToValue: 'Filter to value',
        ariaFilteringOperator: 'Filtering Operator',
        ariaColumnToggleVisibility: 'column toggle visibility',
        ariaColumnGroupToggleVisibility: 'column group toggle visibility',
        ariaRowSelect: 'Press SPACE to select this row',
        ariaRowDeselect: 'Press SPACE to deselect this row',
        ariaRowToggleSelection: 'Press Space to toggle row selection',
        ariaRowSelectAll: 'Press Space to toggle all rows selection',
        ariaSearch: 'Search',
        ariaSearchFilterValues: 'Search filter values'
    }

}
